import { USER_INFO } from '../actions/actions';

// eslint-disable-next-line no-unused-vars
export const updateUser = state => {
    
}

const user = store => next => action => {
    let result = next(action)
    if (action.type === USER_INFO) {
        updateUser(store.getState())
    }
    return result
}

export default user;